import { FunctionComponent } from 'react';
import { DefaultChip } from 'shared/DefaultChip';

export const PublicBetaTag: FunctionComponent = () => {
  return <DefaultChip color="info" label="Public Beta" variant="outlined" />;
};
